var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmailIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    className: "svg-email-icon",
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47.5,
    r: 46.5,
    stroke: "#8F27C7",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 43.1388C33.3333 41.936 33.3333 41.3346 33.632 40.8513C33.9307 40.368 34.4686 40.099 35.5445 39.5611L46.2111 34.2278C47.0889 33.7888 47.5278 33.5694 48 33.5694C48.4721 33.5694 48.911 33.7888 49.7888 34.2278L60.4555 39.5611C61.5313 40.099 62.0693 40.368 62.3679 40.8513C62.6666 41.3346 62.6666 41.936 62.6666 43.1388V58.6667C62.6666 60.5523 62.6666 61.4951 62.0809 62.0809C61.4951 62.6667 60.5523 62.6667 58.6666 62.6667H37.3333C35.4477 62.6667 34.5049 62.6667 33.9191 62.0809C33.3333 61.4951 33.3333 60.5523 33.3333 58.6667V43.1388Z",
    stroke: "#8F27C7",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 44.3333L38.2475 49.2475C38.6226 49.6226 39.1313 49.8333 39.6617 49.8333H56.3382C56.8687 49.8333 57.3774 49.6226 57.7524 49.2475L62.6666 44.3333",
    stroke: "#8F27C7",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmailIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email-icon.73d23f30e64371e3790b03b55553bde3.svg";